import React from "react";
import { Link } from "react-router-dom";
import { getProductBySlug, getProductCategory, isProductInCategory, products } from "../../data/products";
import ProductCardImage from "../Products/ProductCardImage";
import "./HomeProductDiscovery.scss";

const sheetProducts = [
  {
    description: "Our core private label format.",
    slug: "laundry-detergent-sheets",
  },
  {
    description: "3-in-1 enzyme sheet formula.",
    slug: "3-in-1-enzyme-laundry-detergent-sheets",
  },
  {
    description: "5-in-1 solid enzyme formula.",
    slug: "5-in-1-solid-enzyme-laundry-detergent-sheets",
  },
  {
    description: "For baby laundry care.",
    slug: "baby-laundry-detergent-sheets-for-sensitive-skin",
  },
  {
    description: "PVA-free laundry sheet format.",
    slug: "pva-free-laundry-detergent-sheets",
  },
  {
    description: "Dissolvable toilet cleaning sheets.",
    slug: "toilet-bowl-cleaner-sheets",
  },
  {
    description: "Dissolvable floor cleaning format.",
    slug: "floor-cleaning-sheets",
  },
  {
    description: "Glass care in sheet form.",
    slug: "glass-cleaning-sheet",
  },
];

const productCollections = [
  { categoryId: "sheets", slug: "laundry-detergent-sheets" },
  { categoryId: "tablets", slug: "laundry-detergent-tablets" },
  { categoryId: "pods", slug: "laundry-pods" },
  { categoryId: "powders", slug: "laundry-detergent-powder" },
  { categoryId: "fragrance-booster-beads", label: "Fragrance Beads", slug: "fragrance-booster-beads" },
  { categoryId: "stain-removal", slug: "stain-removal-spray" },
];

export function ProductCategories() {
  return (
    <section className="hp-section hp-categories" aria-labelledby="home-categories-heading">
      <div className="hp-container">
        <div className="hp-section-heading">
          <div>
            <p className="hp-eyebrow">Explore the range</p>
            <h2 id="home-categories-heading">Explore Our Sheet Products.</h2>
          </div>
          <Link className="hp-text-link" to="/products">
            Explore All Products
          </Link>
        </div>
        <div className="hp-category-grid">
          {sheetProducts.map(({ description, slug }) => {
            const product = getProductBySlug(slug);
            return (
              <Link className="hp-category-card" to={`/products/${product.slug}`} key={slug}>
                <div className="hp-category-image">
                  <ProductCardImage images={product.images} eager={false} />
                </div>
                <div className="hp-category-copy">
                  <h3>{product.name}</h3>
                  <p className="hp-category-description">{description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function FeaturedProducts() {
  return (
    <section className="hp-section hp-featured" aria-labelledby="home-featured-heading">
      <div className="hp-container">
        <div className="hp-section-heading">
          <div>
            <p className="hp-eyebrow">Product collections</p>
            <h2 id="home-featured-heading">Explore Our Product Collections.</h2>
          </div>
          <Link className="hp-text-link" to="/products">
            View Cleaning Product Range
          </Link>
        </div>
        <div className="hp-featured-grid">
          {productCollections.map(({ categoryId, slug, label }) => {
            const category = getProductCategory(categoryId);
            const name = label || category.name;
            const product = getProductBySlug(slug);
            const secondProduct = products.filter((item) => isProductInCategory(item, categoryId))[1];
            return (
              <Link
                className={`hp-product-card${categoryId === "sheets" ? " hp-product-card--primary" : ""}`}
                to={`/products?category=${category.id}`}
                aria-label={`Explore ${name}: ${category.count} products`}
                key={category.id}
              >
                <div className="hp-product-image">
                  <ProductCardImage images={[product.images[0], secondProduct?.images[0]]} eager={false} />
                </div>
                <div className="hp-product-copy">
                  <h3>{name}</h3>
                  <p className="hp-product-description">{category.count} {category.count === 1 ? "product" : "products"}</p>
                  <span className="hp-product-link">Explore {name}</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
